import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Sparkles, X } from "lucide-react";
import { primaryColor, secondaryColor } from "../constants/colors";

/**
 * Premium Coming Soon Modal
 * Features a modern, sleek design with glassmorphism and brand-aligned colors.
 */
const AppComingSoonModal = ({
  show,
  onHide,
  title = "Coming Soon to iOS",
  body = "We're currently polishing the iDiag experience for Apple devices. Get ready for a seamless health journey on your iPhone and iPad.",
  buttonText = "Notify Me",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="premium-coming-soon-modal"
      backdropClassName="premium-modal-backdrop"
      contentClassName="border-0 bg-transparent"
    >
      <div 
        className="position-relative overflow-hidden shadow-lg p-5 text-center"
        style={{
          background: `linear-gradient(145deg, ${primaryColor} 0%, #0f172a 100%)`,
          borderRadius: "24px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        {/* Animated Background Gradients */}
        <div 
          className="position-absolute" 
          style={{
            top: "-100px",
            right: "-100px",
            width: "300px",
            height: "300px",
            background: `radial-gradient(circle, ${secondaryColor}20 0%, transparent 70%)`,
            filter: "blur(40px)",
            zIndex: 0
          }}
        />
        
        {/* Close Button */}
        <button
          onClick={onHide}
          className="position-absolute border-0 bg-transparent p-2"
          style={{ top: "20px", right: "20px", color: "rgba(255,255,255,0.4)", zIndex: 10 }}
        >
          <X size={24} />
        </button>

        <div className="position-relative z-index-1">
          {/* Icon Badge */}
          <div 
            className="d-inline-flex align-items-center justify-content-center mb-4"
            style={{
              width: "70px",
              height: "70px",
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "20px",
              border: `1px solid ${secondaryColor}40`,
              color: secondaryColor
            }}
          >
            <Sparkles size={32} />
          </div>

          <h3 
            className="fw-bold mb-3 text-white" 
            style={{ fontSize: "1.8rem", letterSpacing: "-0.5px" }}
          >
            {title}
          </h3>

          <p 
            className="mb-5 mx-auto" 
            style={{ 
              color: "#cbd5e1", 
              lineHeight: "1.6", 
              fontSize: "1.05rem",
              maxWidth: "340px"
            }}
          >
            {body}
          </p>

          <Button
            onClick={onHide}
            className="w-100 py-3 fw-bold border-0 shadow-lg"
            style={{
              background: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
              borderRadius: "14px",
              fontSize: "1.1rem",
              transition: "transform 0.2s"
            }}
            onMouseEnter={(e) => e.target.style.transform = "scale(1.02)"}
            onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
          >
            {buttonText}
          </Button>

          <p className="mt-4 mb-0" style={{ color: "#94a3b8", fontSize: "0.85rem" }}>
            Estimated Launch: Q2 2026
          </p>
        </div>
      </div>

      <style jsx global>{`
        .premium-modal-backdrop {
          background-color: rgba(2, 6, 23, 0.85);
          backdrop-filter: blur(8px);
        }
        .premium-coming-soon-modal .modal-dialog {
          max-width: 450px;
        }
      `}</style>
    </Modal>
  );
};

export default AppComingSoonModal;
